import React from 'react'
import App from './App'

function Main() {
    return (
        <div className='bg-dark' style={{ minHeight: "100vh" }}>
            <div className='container font-size-1rem'>
                <App />
            </div >
        </div >

    )
}

export default Main
